import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumbers } = CommonParameters;

export const directDebitCancel_KRAKEN: IMcAppType = {
  name: "directDebitCancel_KRAKEN",
  path: "/my/direct-debit/cancel",
  parameters: {
    properties: { accountNumbers },
  },
  description: "Cancel Direct Debit for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Cancel direct debit",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "directDebitCancel",
    customerType: CustomerType.kraken,
  },
};
